export const RESPONSE_STATUSES = {
    INTERNAL_SERVER_ERROR: 500,
    NOT_FOUND: 404,
    BAD_REQUEST: 400,
    CONFLICT: 409,
};
